module.exports = __webpack_public_path__ + "img/office.d85b1970.svg";